import type { ComponentStyleConfig } from "@chakra-ui/react";

export const TableTheme: ComponentStyleConfig = {
  baseStyle: {
    caption: {
      whiteSpace: "nowrap",
    },
  },
  variants: {
    basic: {
      thead: {
        tr: {
          th: {
            textTransform: "capitalize",
            fontWeight: "black",
            py: 2,
            px: 2,
            "&.current": {
              pos: "relative",
              bg: "brand.gray.110",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "100%",
                bg: "brand.gray.110",
                height: "0.5rem",
                borderRadius: "5px 5px 0 0",
                left: 0,
                top: "-0.5rem",
              },
            },
            "&.highlighted": {
              pos: "relative",
              bg: "brand.skyblue.10",
              border: "1px solid",
              borderColor: "brand.skyblue.100",
              borderBottom: "none",
              borderTop: "none",

              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "calc(100% + 2px)",
                bg: "brand.skyblue.10",
                height: "0.5rem",
                borderRadius: "5px 5px 0 0",
                border: "1px solid",
                borderColor: "brand.skyblue.100",
                borderBottom: "none",
                left: "-1px",
                top: "-0.5rem",
              },
            },
          },
        },
      },
      tbody: {
        tr: {
          fontSize: "sm",
          td: {
            borderBottom: "1px solid",
            borderColor: "brand.gray.110",
            py: 2,
            px: 2,
            "&.current": {
              bg: "brand.gray.110",
            },
            "&.highlighted": {
              bg: "brand.skyblue.10",
              border: "1px solid",
              borderColor: "brand.skyblue.100",
              borderTop: "none",
              borderBottomColor: "brand.gray.110",
            },
          },
          "&:last-of-type": {
            "td.current": {
              pos: "relative",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "100%",
                bg: "brand.gray.110",
                height: "0.5rem",
                borderRadius: "0 0 5px 5px",
                left: 0,
                bottom: "-8px",
              },
            },
            "td.highlighted": {
              pos: "relative",
              _after: {
                display: "block",
                content: '""',
                pos: "absolute",
                width: "calc(100% + 2px)",
                bg: "brand.skyblue.10",
                height: "0.5rem",
                borderRadius: "0 0 5px 5px",
                border: "1px solid",
                borderColor: "brand.skyblue.100",
                borderTop: "none",
                left: "-1px",
                bottom: "-8px",
              },
            },
          },
          "&.has-errors": {
            bg: "brand.red.10",
            borderLeft: "4px solid",
            borderLeftColor: "brand.red.100",
            "td.has-error": {
              bg: "brand.red.20",
              color: "brand.red.100",
            },
          },
        },
      },
    },
    striped: {
      tbody: {
        tr: {
          "&.has-errors": {
            borderLeft: "4px solid",
            borderLeftColor: "brand.red.100",
            "&:nth-of-type(odd)": {
              bg: "brand.red.10",
            },
            "&:nth-of-type(even)": {
              bg: "red.100",
            },
            td: {
              bg: "transparent",
              "&.has-error": {
                color: "brand.red.100",
                fontWeight: "bold",
                borderBottom: "2px solid",
                borderBottomColor: "brand.red.100",
              }
            }
          }
        }
      }
    }
  },
};
